import type { SchemaData, SchemaStation, SchemaStationTimetable } from '../../schema/types'

/**
 * Station-wide timetable for a cluster: a multi-line station is several
 * schema records (one per line) sharing a naptanId, each carrying its
 * own line's directions. "Open today" describes the STATION, so the
 * Overview aggregates every member's directions — one record alone
 * understates the service day (Baker Street: Bakerloo's 05:37–00:27
 * vs the cluster-wide 04:57–00:56).
 */
export function clusterTimetable(
  schema: SchemaData,
  station: SchemaStation,
): SchemaStationTimetable | undefined {
  if (station.naptanId === undefined) return station.stationTimetable
  const directions = schema.stations
    .filter((s) => s.naptanId === station.naptanId)
    .flatMap((s) => s.stationTimetable?.directions ?? [])
  return directions.length > 0 ? { directions } : undefined
}
